import React, { useState } from "react";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Scrollspy from "react-scrollspy";

import Image from "next/image";
import Link from "next/link";
import AOS from "aos";

import Map from "@/public/static/images/map.png";
import Network1 from "@/public/static/images/network_01.jpg";
import Network2 from "@/public/static/images/network_02.jpg";
import Network3 from "@/public/static/images/network_03.jpg";
import Network4 from "@/public/static/images/network_04.jpg";
import Network5 from "@/public/static/images/network_05.jpg";
import Network6 from "@/public/static/images/network_06.jpg";
import Network7 from "@/public/static/images/network_07.jpg";
import Network8 from "@/public/static/images/network_08.jpg";
import Network9 from "@/public/static/images/network_09.jpg";

import Network11 from "@/public/static/images/network_11.jpg";
import Network12 from "@/public/static/images/network_12.jpg";

import Network13 from "@/public/static/images/network_13.jpg";
import Network14 from "@/public/static/images/network_14.jpg";
import Network15 from "@/public/static/images/network_15.jpg";
import Network16 from "@/public/static/images/network_16.jpg";
import Network17 from "@/public/static/images/network_17.jpg";
import Network18 from "@/public/static/images/network_18.jpg";
import Network19 from "@/public/static/images/network_19.jpg";
import Network20 from "@/public/static/images/network_20.jpg";
import Network21 from "@/public/static/images/network_21.jpg";
import Network22 from "@/public/static/images/network_22.jpg";

function network() {
  AOS.init({
    offset: 200,
    duration: 600,
    easing: "ease-in-out-sine",
    delay: 200,
    mirror: true,
  });

  return (
    <div className="wrapper">
      <Header />
      <section className="pro-j">
        <div className="container">
          <div className="row">
            <div className="col-12 top-banner">
              <div className="top_banner-inner">
                <h3>
                  With locations in Japan, Europe, U.S., China and Southeast
                  Asia,
                  <br />
                  we shape content to support our clients in engaging
                  <br />
                  with their audiences all over the world.
                </h3>
                <h2>
                  The ITP global network
                  <br />
                  encompasses 39 offices in 10 countries.
                </h2>
              </div>
            </div>
            <div className="col-12 map-banner">
              <Image
                loading="lazy"
                src={Map}
                alt="ITP global network"
                className="img-fluid mx-auto"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-lg-4 list-network">
              <nav id="network" className="list-network_link">
                <Scrollspy
                  items={["japan", "asia", "sea", "europe", "usa"]}
                  currentClassName="is-current"
                  className="nav nav-network"
                >
                  <li className="nav-item">
                    <a className="nav-link japan" href="#japan">
                      Japan
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link asia" href="#asia">
                      Asia
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link sea" href="#sea">
                      Sea
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link europe" href="#europe">
                      Europe
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link usa" href="#usa">
                      USA
                    </a>
                  </li>
                </Scrollspy>
              </nav>
            </div>

            <div className="co-12 col-lg-8 network_box-detail">
              <section id="japan" className="network_detail">
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network1}
                            alt="Kyoto Office"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Kyoto</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder t-darkblue">Headquarters</p>

                          <p>
                            Ogawa Nishiiru, Marutamachi-Dori, Nakagyo-ku, Kyoto
                            604-0087
                          </p>
                          <p>
                            <span>TEL:</span> 075-211-9111
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network13}
                            alt="Kyoto Plant"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Kyoto</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">
                            ITP Imaging Products Kyoto Plant
                          </p>
                          <p>
                            61 Kamitoba Waranden-cho, Minami-ku, Kyoto 601-8133
                          </p>
                          <p>
                            <span>TEL:</span> 075-671-8800
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network14}
                            alt="Osaka Office"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Osaka</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">Osaka Office</p>
                          <p>1-23-8 Shinmachi, Nishi-ku, Osaka 550-0013</p>
                          <p>
                            <span>TEL:</span> 06-6578-0370
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body"></div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Osaka</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer mt-5">
                          <p className="fw-bolder">
                            ITP Shinwa Kansai Logistics Center
                          </p>
                          <p>
                            5-43 Shinden Kitamachi, Daito, Osaka Prefecture
                            574-0052
                          </p>
                          <p>
                            <span>TEL:</span> 072-872-6450
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body"></div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Okayama</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer mt-5">
                          <p className="fw-bolder">Okayama Branch Office</p>
                          <p>
                            1-6-3 Nishifurumatsu, Kita-ku, Omu VII Building, 2nd
                            Floor, Okayama 700-0927
                          </p>
                          <p>
                            <span>TEL:</span> 086-246-7350
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body"></div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Hiroshima</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer mt-5">
                          <p className="fw-bolder">Hiroshima Branch Office</p>
                          <p>
                            3-16 Nakamachi, Naka Ward, Namiki Hiroun Building,
                            3rd Floor, Hiroshima 730-0037
                          </p>
                          <p>
                            <span>TEL:</span> 082-248-4820
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network15}
                            alt="Osaka Office"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Fukuoka</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">Kyushu Office</p>
                          <p>
                            3-3-22 Hakataeki-Higashi, Hakata-ku, ITP Kyushu
                            Office Building, Fukuoka 812-0013
                          </p>
                          <p>
                            <span>TEL:</span> 092-415-5211
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network16}
                            alt="Nagoya Office"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Nagoya</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">Nagoya Office</p>
                          <p>
                            3-3-33 Meieki Minami, Nakamura-ku, Nagoya 450-0003
                          </p>
                          <p>
                            <span>TEL:</span> 052-589-1541
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network17}
                            alt="Tajimi Office"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Gifu</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer mt-5">
                          <p className="fw-bolder">Tajimi Office</p>
                          <p>
                            1-60-1 Kanaokacho, Tajimi, Gifu Prefecture 507-0016
                          </p>
                          <p>
                            <span>TEL:</span> 0572-21-3210
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network18}
                            alt="Nagoya Plant"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Aichi</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">
                            Inazawa Office
                            <br />
                            ITP Imaging Products Nagoya Plant
                          </p>
                          <p>
                            121 Saiwaicho, Inazawa, Aichi Prefecture 492-8221
                          </p>
                          <p>
                            <span>TEL:</span> 0587-32-6221
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network19}
                            alt="ITP Logistics Center"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Aichi</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">ITP Logistics Center</p>
                          <p>
                            3-7-4 Kitaichibahonmachi, Inazawa, Aichi Prefecture
                            492-8178
                          </p>
                          <p>
                            <span>TEL:</span> 0587-33-6050
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body"></div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Shizuoka</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer mt-5">
                          <p className="fw-bolder">Hamamatsu Office</p>
                          <p>
                            5-26-1 Sanarudai, Naka-ku, Hamamatsu, Shizuoka
                            Prefecture 432-8021
                          </p>
                          <p>
                            <span>TEL:</span> 053-488-4121
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network20}
                            alt="Ochanomizu Office"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Tokyo</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">Ochanomizu Office</p>
                          <p>2-18-2 Sotokanda, Chiyoda-ku, Tokyo 101-0021</p>
                          <p>
                            <span>TEL:</span> 03-3255-8911
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network21}
                            alt="Hongo Office"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Tokyo</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">Hongo Office</p>
                          <p>2-25-7 Yushima, Bunkyo-ku, Tokyo 113-0034</p>
                          <p>
                            <span>TEL:</span> 03-6803-0246
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network22}
                            alt="ITP Imaging Products Tokyo Plant"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Tokyo</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">
                            ITP Imaging Products Tokyo Plant
                          </p>
                          <p>6-3-38 Toyo, Koto-ku, Tokyo 135-0016</p>
                          <p>
                            <span>TEL:</span> 03-3699-0711
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body"></div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Miyagi</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer mt-5">
                          <p className="fw-bolder">Tohoku Branch Office</p>
                          <p>
                            12-21 Futsukamachi, Aoba-ku, Shinto Futsukamachi
                            Building Room 403, Sendai, Miyagi Prefecture
                            980-0802
                          </p>
                          <p>
                            <span>TEL:</span> 022-722-2505
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body"></div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Sapporo</h1>
                            <h4 className="card-text">Japan</h4>
                          </div>
                        </div>
                        <div className="card-footer mt-5">
                          <p className="fw-bolder">Sapporo Branch Office</p>
                          <p>
                            3-1 Kita 2 Jonishi, Chuo-ku, Taiyo Seimei Sapporo
                            Building, 6th Floor, Sapporo 060-0002
                          </p>
                          <p>
                            <span>TEL:</span> 011-219-1720
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section id="asia" className="network_detail">
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network2}
                            alt="ITP Advertisement (Shanghai) Co., Ltd."
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Shanghai</h1>
                            <h4 className="card-text">China</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">
                            ITP Advertisement (Shanghai) Co., Ltd.
                          </p>
                          <p>
                            1701 Beijing West Road, Jing'an Zhong Hua Building
                            Suite 607, Shanghai, China 200040
                          </p>
                          <p>
                            <span>TEL:</span> +86(0)21-5382-6237
                          </p>
                          <a
                            href="http://www.itp-china.com/"
                            className="t-darkblue"
                          >
                            http://www.itp-china.com/
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network3}
                            alt="ITP Inc. Taiwan Branch"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Taipei</h1>
                            <h4 className="card-text">Taiwan</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">ITP Inc. Taiwan Branch</p>
                          <p>
                            Rm. 1, 6F., No. 369, Fuxing N. Rd., Songshan Dist.,
                            Taipei City 108001 , Taiwan (R.O.C.)
                          </p>
                          <div className="d-flex g-3 mb-1">
                            <p>
                              <span>TEL:</span>{" "}
                            </p>
                            <p className="ms-1">
                              +886-2-6608-9886 <br />
                              +886-978-576-774
                            </p>
                          </div>

                          <a
                            href="http://www.itp-taiwan.com.tw"
                            className="t-darkblue"
                          >
                            http://www.itp-taiwan.com.tw
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section id="sea" className="network_detail">
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network4}
                            alt="ITP Asia Co.,Ltd. (Head Office)"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Bangkok</h1>
                            <h4 className="card-text">Thailand</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">
                            ITP Asia Co.,Ltd. (Head Office)
                          </p>
                          <p>
                            589/160 Central City Tower, Room OF3004, 30th Floor,
                            Debaratana Road, Bangna Nuea, Bangna, Bangkok
                            10260 Thailand
                          </p>
                          <p>
                            <span>TEL:</span> +66(0)2-745-6050
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network5}
                            alt="ITP MYANMAR Co., Ltd."
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Yangon</h1>
                            <h4 className="card-text">Myanmar</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">ITP MYANMAR Co., Ltd.</p>
                          <p>
                            No(Sa/205), Room(2/C), Royal Zawtika Condo, Lay
                            Daung Kan Road, Za/North Ward, Thingangyun Township,
                            Yangon, Myanmar.
                          </p>
                          <p>
                            <span>TEL:</span> +959-895555987
                          </p>
                          <p>
                            <span>E-mail:</span>{" "}
                            <a
                              href="mailto:info-myanmar@itp.co.th"
                              className="t-black"
                            >
                              info-myanmar@itp.co.th
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network6}
                            alt="ITP & CREASIA Co., Ltd."
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Ho Chi Minh City</h1>
                            <h4 className="card-text">Vietnam</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">
                            ITP & CREASIA Co., Ltd.
                            <br />
                            Ho Chi Minh City (Head Office)
                          </p>
                          <p>
                            8th Floor, Dinh Le Building, 01 Dinh Le Street, Ward
                            13, District 4.HCMC, Vietnam
                          </p>
                          <p>
                            <span>TEL:</span> +84(0)28-3825-5130
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network7}
                            alt="ITP & CREASIA Co., Ltd.,"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Hanoi</h1>
                            <h4 className="card-text">Vietnam</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">
                            ITP & CREASIA Co., Ltd., <br />
                            Hanoi Branch Office
                          </p>
                          <p>
                            302 Cau Giay Street, Discovery Complex Building,
                            17th Floor, Room No.1712, Dich Vong Ward, Cau Giay
                            District, Hanoi, Vietnam
                          </p>
                          <p>
                            <span>TEL:</span> +84(0)24-7779-98886
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network8}
                            alt="ITP-SVEN PHILIPPINES INC."
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Manila</h1>
                            <h4 className="card-text">The Philippines</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">ITP-SVEN PHILIPPINES INC.</p>
                          <p>
                            29 Bulletin St. West Triangle, Quezon City, Metro
                            Manila, Philippines 1104
                          </p>
                          <p>
                            <span>TEL:</span> +63(0)2-415-7836
                          </p>
                          <a
                            className="t-darkblue"
                            href="http://www.itp-sven.ph/"
                          >
                            http://www.itp-sven.ph/
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section id="europe" className="network_detail">
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network9}
                            alt="ITP Inc. Belgium Branch"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Brussels</h1>
                            <h4 className="card-text">Belgium</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">
                            ITP Inc. Belgium Branch
                            <br />
                            (ITP Europe Brussels)
                          </p>
                          <p>
                            Fountain Plaza, Belgicastraat 1/8, 1930 Zaventem
                            (Brussels), Belgium
                          </p>
                          <p>
                            <span>TEL:</span> +32(0)2-721-5100
                          </p>
                          <a
                            className="t-darkblue"
                            href="https://www.itp-europe.com/"
                          >
                            https://www.itp-europe.com/
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          {/* <Image loading="lazy"
                          src={Network9}
                          alt="ITP Inc. Slovakia Branch"
                          className="img-fluid mx-auto  network-img"
                        /> */}
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Kosice</h1>
                            <h4 className="card-text">Slovakia</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">
                            ITP Inc. Slovakia Branch
                            <br />
                            (ITP Europe Kosice)
                          </p>
                          <p>
                            Werferova 1/2582, 040 11 Kosice, Slovakia Republic
                          </p>
                          <p>
                            <span>TEL:</span> +421(0)55-321-1531
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section id="usa" className="network_detail">
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network11}
                            alt="ITP STRATEGIC LA, LLC"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Los Angeles</h1>
                            <h4 className="card-text">The U.S.A.</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">ITP STRATEGIC LA, LLC</p>
                          <p>
                            21151 S. Western Ave. Suite 14, Torrance, CA 90501
                            USA
                          </p>
                          <p>
                            <span>TEL:</span> +1310-323-9865
                          </p>
                          <a
                            href="http://www.itpstrategic.com/"
                            className="t-darkblue"
                          >
                            http://www.itpstrategic.com/
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="network_detail-inner"
                  data-aos="fade-left"
                  data-aos-duration="800"
                >
                  <div className="row row-cols-1 row-cols-md-2 g-4">
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <Image
                            loading="lazy"
                            src={Network12}
                            alt="ITP STRATEGIC TX, LLC"
                            className="img-fluid mx-auto  network-img"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card h-100">
                        <div className="card-body">
                          <div className="network_heading-place text-end">
                            <h1 className="top-box">Dallas</h1>
                            <h4 className="card-text">The U.S.A.</h4>
                          </div>
                        </div>
                        <div className="card-footer">
                          <p className="fw-bolder">ITP STRATEGIC TX, LLC</p>
                          <p>
                            5700 Tennyson Parkway, Suite 300, Plano, TX 75024
                            USA
                          </p>
                          <p>
                            <span>TEL:</span> +1-469-808-1060
                          </p>
                          <a
                            href="http://www.itpstrategic.com/"
                            className="t-darkblue"
                          >
                            http://www.itpstrategic.com/
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default network;
